<template>
  <div
    :class="
      horizontal
        ? 'row items-center no-wrap'
        : 'column items-center justify-center no-wrap'
    "
    class="text-positive q-mr-sm"
    style="margin-top: 2px"
  >
    <q-icon
      name="sym_r_trending_down"
      :style="
        horizontal
          ? 'font-size: 22px;line-height: 22px'
          : 'font-size: 20px;line-height: 20px'
      "
    />
    <span
      class="leading-none text-weight-bold --text-sm"
      :style="horizontal ? 'margin-left: 2px' : 'margin-top: -4px'"
    >
      ${{ formatNumber(amountChange, true) }}
    </span>
  </div>
</template>

<script>
export default {
  name: "PriceDropLabel",
  props: {
    amountChange: {
      type: String,
      required: true
    },
    horizontal: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss"></style>
